import { DetailResponseData, ListResponseData } from "./base";
import { TagListItem } from "./tag";

export enum LinkSectionEnum {
  PROFILE = "profile",
  EDUCATION = "education",
  JOB = "job",
}

export enum LinkTypeEnum {
  ARTICLE = "article",
  YOUTUBE = "youtube",
  VIMEO = "vimeo",
  LINKEDIN = "linkedin",
  SPOTIFY = "spotify",
  ELITE_PROSPECTS = "elite_prospects",
}

export interface LinkListItem {
  id: string;
  type: LinkTypeEnum;
  value: string;
  link_tags: TagListItem[];
}

export interface LinksResponseData extends ListResponseData<LinkListItem> {}

export interface LinkDetail extends LinkListItem {}

export interface CreateLinkPayload {
  type: LinkTypeEnum;
  value: string;
}

export interface CreateLinkResponseData extends DetailResponseData<LinkDetail> {}

export interface UpdateLinkPayload {
  type: LinkTypeEnum;
  value: string;
}

export interface UpdateLinkResponseData extends DetailResponseData<LinkDetail> {}
